import { render } from "./TextareaFieldComponent.vue?vue&type=template&id=35fe79f0"
import script from "./TextareaFieldComponent.vue?vue&type=script&lang=js"
export * from "./TextareaFieldComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__